/** 福利中心 - banner子节点 */
var Event = require("cocos/framework/components/event");
const WelfareCenterLogic = require("./WelfareCenterLogic");
const CountDownCmpt = require("clover/panel/component/common/CountDownCmpt");
const TreasureBoxPanel = require("../TreasureBox/TreasureBoxPanel");
const MonthTicketManager = require("../MonthTicket/MonthTicketManager");
const InteractiveInviteLogic = require("../../clover/scene/component/homescene/InteractiveInvite/InteractiveInviteLogic");
const AIPkgManager = require("../AIPackage/AIPkgManager");

var WelfareCenterBannerItem = xClass("WelfareCenterBannerItem", Event, function () {
    return cc.CSLoader.createNode("cocos/welfare_welfare_item.csb");
})

WelfareCenterBannerItem.prototype.ctor = function () {
    var self = this;
    self.bind(self);
    self.initUI();
}

WelfareCenterBannerItem.prototype.initUI = function () {
    let self = this;
    self.time = self.getChildByName("time");
    self.timeL = self.time.getChildByName("label");
    self.dot = self.getChildByName("dot");
    self.new = self.getChildByName("new");

    self.bgSprite = cc.Sprite.create();
    self.bgSprite.setPosition(360, 113);
    self.addChild(self.bgSprite, -1);

    quickBuildUIButtonNoAction(self, function () {
        self.onClick();
    });
    self.setSwallowTouches(false);

    //监听倒计时改动，暂无倒计时销毁逻辑
    self._kWelfareCenterAction = function (event) {
        if (self.data && event.data.id == self.data.id) {
            self.data.countDown = event.data.countDown;
            self.data.redDot = event.data.redDot;
            //
            self.initFlag();
            self.initCountDown();
            console.log("福利中心事件 : banner刷新倒计时、红点  " + event.data.id);
        }
    }
    GlobalEventDispatcher.getInstance().addEventListener(
        kGlobalEvents.kWelfareCenterAction,
        self._kWelfareCenterAction,
    );

    //监听面板打开事件
    self._kWelfareCenterPanel = function (event) {
        WelfareCenterLogic.addNewActivity(event.data);
        if (self.data && event.data.id == self.data.id) {
            self.initFlag();
            console.log("福利中心事件 : banner刷新 '!'  " + event.data.id);
        }
    }
    GlobalEventDispatcher.getInstance().addEventListener(
        kGlobalEvents.kWelfareCenterPanel,
        self._kWelfareCenterPanel,
    );
}

WelfareCenterBannerItem.prototype.initData = function (data) {
    let self = this;
    self.data = data;

    let spr = `welfare/welfare_banner_${WelfareCenterLogic.activityName[data.id]}.png`;
    if (data.id == WelfareCenterId.aiPkg && AIPkgManager.getInstance().getCube() == "b") {
        spr = `welfare/welfare_banner_aipkg.png`;
    }
    self.bgSprite.initWithSpriteFrameName(spr)

    if (self.data.id == WelfareCenterId.unknown) {
        self.time.setVisible(false);
        self.dot.setVisible(false);
        self.new.setVisible(false);
    } else {
        self.initFlag();
        self.initCountDown();
    }
}

//"!" 、红点
WelfareCenterBannerItem.prototype.initFlag = function () {
    let self = this;
    self.dot.setVisible(false);
    self.new.setVisible(false);

    if (WelfareCenterLogic.showActivityIds.indexOf(self.data.id) == -1) {
        self.new.setVisible(true);
    } else {
        self.dot.setVisible(!!self.data.redDot);
    }
}

//倒计时
WelfareCenterBannerItem.prototype.initCountDown = function () {
    let self = this;
    self.time.setVisible(false);

    if (self.timeL._countDown) {
        self.timeL._countDown.destroy();
    }
    if (self.data.countDown && WelfareCenterLogic.config[self.data.id].showTime) {
        self.time.setVisible(true);
        self.timeL._countDown = CountDownCmpt.AutoRun(self.timeL, self.data.countDown, null, function (remain, day, hour, min, sec) {
            if (day > 0) {
                return day + "天" + hour + "小时";
            } else {
                return string.format("%02d:%02d:%02d", hour, min, sec);
            }
        });
    }
}

WelfareCenterBannerItem.prototype.onClick = function () {
    let self = this;
    if (!self.data || self.data.id == WelfareCenterId.unknown) return;
    if (!self.checkTime(1500)) return;
    //
    switch (self.data.id) {
        case WelfareCenterId.starDraw:
            let homeScene = require("clover/scene/HomeScene").getInstance()
            homeScene.showStarDraw();
            break;
        case WelfareCenterId.treasureBox:
            TreasureBoxPanel.show();
            break;
        case WelfareCenterId.freeGift:
            let doFunction = () => {
                InteractiveInviteLogic.openMain(() => {
                }, (evt) => {
                    Toast.make(curryQuickGetErrorText(evt ? evt.data : null));
                }, () => {
                });
            }
            AuthorizeMgr.checkAuthorizeByScope("FriendInteraction", doFunction, doFunction, true, true)
            break;
        case WelfareCenterId.freeCoin:
            break;
        case WelfareCenterId.goldTurn:
            break;
        case WelfareCenterId.monthTicket:
            self.onClickMonthTicket();
            break;
        case WelfareCenterId.battlePass:
            break;
        case WelfareCenterId.specialShop:
            break;
        case WelfareCenterId.aiPkg:
            break;
        case WelfareCenterId.endlessTreasure:
            break;
        case WelfareCenterId.islandTreasure:
            break;
        case WelfareCenterId.tetris:
            break;
        default:
            console.warn("未处理的id");
            break;
    }
    //
    const plt = WelfareCenterLogic.activityName[self.data.id];
    const type = WelfareCenterLogic.dcInfo.type || "pay";
    const pf = WelfareCenterLogic.dcInfo.pf || "page";
    let params = WelfareCenterLogic.dcSimple("page_click", {
        session: WelfareCenterLogic.dcInfo.session,
        pf, plt, type
    });
    const session = params.session;

    const Event = require("hecore/EventDispatcher").Event;
    GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kWelfareCenterClick,
        {
            id: self.data.id,
            session,
        }))
}

WelfareCenterBannerItem.prototype.onClickMonthTicket = function () {
    let monthTicketManager = MonthTicketManager.getInstance();

    monthTicketManager.infoHttp().then(function () {
        monthTicketManager.showMainPanel(() => { }, () => { }, "welfare_center")
    }).catch((evt) => {
        Toast.make(quickGetErrorText(evt.data, getText("error.tip.load_res_error")))
    })
}

WelfareCenterBannerItem.prototype.onCleanup = function () {
    let self = this;
    if (self._kWelfareCenterAction) {
        GlobalEventDispatcher.getInstance().removeEventListener(
            kGlobalEvents.kWelfareCenterAction,
            self._kWelfareCenterAction,
        );
        self._kWelfareCenterAction = null;
    }

    if (self._kWelfareCenterPanel) {
        GlobalEventDispatcher.getInstance().removeEventListener(
            kGlobalEvents.kWelfareCenterPanel,
            self._kWelfareCenterPanel,
        );
        self._kWelfareCenterPanel = null;
    }

    if (self.timeL._countDown) {
        self.timeL._countDown.destroy();
    }
}

WelfareCenterBannerItem.prototype.checkTime = function (interval = 1000) {
    let self = this;
    let now = new Date().getTime();
    if (!self._clickTime) {
        self._clickTime = 0;
    }
    if (now - self._clickTime >= interval) {
        self._clickTime = now;
        return true;
    } else {
        return false;
    }
}


module.exports = WelfareCenterBannerItem;
